export enum CategoryType {
    news = 1,
    newsHome = 2,
}